import { ChevronRight } from "lucide-react";
import { DAYS } from "@/features/onboarding/step4/types";

interface OpeningDaysListProps {
  openingDays: string[];
  onDayClick?: (dayId: string) => void;
}

export function OpeningDaysList({ openingDays, onDayClick }: OpeningDaysListProps) {
  return (
    <div>
      <h3 className="mb-3 text-sm font-semibold text-gray-700">Jours d'ouverture</h3>

      <div className="space-y-2">
        {DAYS.map((day) => {
          const isOpen = openingDays.includes(day.id);

          return (
            <button
              key={day.id}
              onClick={() => onDayClick?.(day.id)}
              className={`flex w-full items-center justify-between rounded-lg border px-3 py-2 text-left transition-colors ${
                isOpen
                  ? "border-orange-200 bg-orange-50 hover:bg-orange-100"
                  : "border-gray-200 bg-gray-50 text-gray-400"
              }`}
            >
              <div className="flex items-center gap-2">
                {/* Checkbox indicator */}
                <div
                  className={`flex h-4 w-4 items-center justify-center rounded-full border ${
                    isOpen
                      ? "border-orange-500 bg-orange-500"
                      : "border-gray-300 bg-white"
                  }`}
                >
                  {isOpen && (
                    <div className="h-2 w-2 rounded-full bg-white" />
                  )}
                </div>
                <span
                  className={`text-sm font-medium ${
                    isOpen ? "text-gray-900" : "text-gray-400"
                  }`}
                >
                  {day.label}
                </span>
              </div>
              {isOpen && (
                <ChevronRight className="h-4 w-4 text-gray-400" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
